"use client";

import { getYzsaId } from "@yardzen/next-client-util";
import { useEffect, useState } from "react";

/**
 * Who the RUM session belongs to, as the host app knows it:
 * - an object: logged in
 * - `null`: known to be logged out
 * - `undefined`: the app does not report auth (or the session is still
 *   loading), so the component leaves user identity alone
 */
export type RumUserData = { email?: string; userId?: string } | null;

export function useAnonymousId(): string | undefined {
  const [anonymousId, setAnonymousId] = useState<string | undefined>();

  // Get anonymous ID once on mount (getYzsaId now uses internal cache)
  useEffect(() => {
    try {
      setAnonymousId(getYzsaId());
    } catch (error) {
      console.warn("[Datadog] Failed to read anonymous ID:", error);
    }
  }, []);

  return anonymousId;
}
